import React, { Component } from 'react';

import { Form, Input } from 'antd';

const FormItem = Form.Item;

class Username extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };
    }

    handleChange(data) {
        this.setState({
            value: data.loginName
        });

        if(this.props.handleChange) {
            this.props.handleChange(data);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    render() {
        const { style, label, getFieldDecorator } = this.props;
        const { value } = this.state;
        return (
            <FormItem label={label || "登录名"}>
                {
                    getFieldDecorator ? (
                        getFieldDecorator('loginName', {
                            initialValue: value,
                            rules: [{
                                required: true,
                                message: '请输入登录名',
                            }],
                        })(
                            <Input
                                value={value}
                                placeholder='请输入...'
                                style={style || {width: 240}}
                                onChange={(event) => {
                                    this.handleChange({ 
                                        loginName: event.target.value
                                    });
                                }}
                            ></Input>
                        )
                    ) : (
                        <Input
                            value={value}
                            placeholder='请输入...'
                            style={style || {width: 240}}
                            onChange={(event) => {
                                this.handleChange({ 
                                    loginName: event.target.value
                                });
                            }}
                        ></Input>
                    )
                }
                
            </FormItem>
        );
    }
}

export default Username;